import {UrlObj} from "./other/UrlObj";
import {ServerService} from "../services/server.service";

export class RegioneData {
  id?: number;
  nome?: string;

}

export class Regione {

  data:RegioneData = {}

  constructor(data:RegioneData) {
    // assegno al mio oggetto data (è un json)
    if(!data) data = {}
    Object.assign(this.data, data)
  }

   public static BASE_URL(path=null, queryParams={}):string{
      let url:UrlObj = new UrlObj("/api/regioni", queryParams);
      if(path) url.url += path;
      return url.toString()
   }

   static async getRegioni():Promise<Regione[]> {
     return new Promise((resolve, reject) => {
        ServerService.instance.getAll(Regione, `/api/regioni`).then(res=>{
           resolve(res)
        }).catch(err=>{
           reject(err)
        })
     })
   }

}
